import CheckMark from 'app/design/images/checkmark';
import { Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import type { useUserCurrency } from 'app/network/user';
import { Trans } from 'react-i18next';
import { View } from 'react-native';
import type { FreeSubParams } from './free-sub';

export function FreeSubActivatedSubscription({
  userCurrency,
  userGotFreeSub,
  width,
}: {
  userCurrency: ReturnType<typeof useUserCurrency>;
  userGotFreeSub: FreeSubParams['userGotFreeSub'];
  width: number;
}) {
  if (!userGotFreeSub) return null;

  return (
    <Row alignItems="center" style={{ marginHorizontal: 40, marginTop: -10, marginBottom: -10 }}>
      <View style={{ paddingTop: 8 }}>
        <CheckMark />
      </View>
      <Text
        style={{ fontSize: 18, textAlign: 'center', width: width - 2 * 40 - 74, paddingHorizontal: 5 }}
        variant="bodyBase"
      >
        <Trans
          components={{ strong: <Text fontWeight="700" /> }}
          i18nKey={`subscriptionActivatedText.${userCurrency}`}
          ns="free-sub"
        />
      </Text>
    </Row>
  );
}
